import { Link } from "react-router-dom";

const Opinie = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Opinie medicală</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Acasă</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Opinie medicală
            </li>
          </ol>
        </nav>
        <div className="container history">
          <div className="row">
            <div className="col-lg-4">
              <h2 className="mb-4">Opinie medicală</h2>
              <div className="mb-4 p-4 bg-light rounded">
                <p className="mb-1">
                  Formular:{" "}
                  <a href="https://forms.gle/4qXyotPx59pP6bRt7">Link</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Opinie;
